import LoginComp from 'src/components/login'

export default LoginComp
